// action types
import { createRequestTypes } from "../../utils";

// Fetch stages
export const FETCH_STAGES_OVERVIEW = createRequestTypes("FETCH_STAGES_OVERVIEW");
export const FETCH_BATCH_STAGES = createRequestTypes("FETCH_BATCH_STAGES");

// Stage actions
export const COMPLETE_STAGE = createRequestTypes("COMPLETE_STAGE");
export const ADD_STAGE_NOTE = createRequestTypes("ADD_STAGE_NOTE");
export const UPDATE_STAGE = createRequestTypes("UPDATE_STAGE");

// UI State
export const SET_STAGE_FILTERS = 'SET_STAGE_FILTERS';
export const SET_STAGE_SORT = 'SET_STAGE_SORT';
export const CLEAR_STAGES = 'CLEAR_STAGES';

// ==================== STAGES OVERVIEW ====================

export const fetchStagesOverviewRequest = (filters = {}) =>
    ({ type: FETCH_STAGES_OVERVIEW.REQUEST, payload: filters });

export const fetchStagesOverviewSuccess = (stages) =>
    ({ type: FETCH_STAGES_OVERVIEW.SUCCESS, payload: stages });

export const fetchStagesOverviewFailure = (error) =>
    ({ type: FETCH_STAGES_OVERVIEW.FAILURE, payload: error });

// ==================== BATCH STAGES ====================

export const fetchBatchStagesRequest = (batchId) =>
    ({ type: FETCH_BATCH_STAGES.REQUEST, payload: { batchId } });

export const fetchBatchStagesSuccess = (stages) =>
    ({ type: FETCH_BATCH_STAGES.SUCCESS, payload: stages });

export const fetchBatchStagesFailure = (error) =>
    ({ type: FETCH_BATCH_STAGES.FAILURE, payload: error });

// ==================== STAGE ACTIONS ====================

export const completeStageRequest = (stageId, endDate = null) =>
    ({ type: COMPLETE_STAGE.REQUEST, payload: { stageId, endDate } });

export const completeStageSuccess = (stage) =>
    ({ type: COMPLETE_STAGE.SUCCESS, payload: stage });

export const completeStageFailure = (error) =>
    ({ type: COMPLETE_STAGE.FAILURE, payload: error });

export const addStageNoteRequest = (stageId, note, append = true) =>
    ({ type: ADD_STAGE_NOTE.REQUEST, payload: { stageId, note, append } });

export const addStageNoteSuccess = (stage) =>
    ({ type: ADD_STAGE_NOTE.SUCCESS, payload: stage });

export const addStageNoteFailure = (error) =>
    ({ type: ADD_STAGE_NOTE.FAILURE, payload: error });

export const updateStageRequest = (stageId, stageData) =>
    ({ type: UPDATE_STAGE.REQUEST, payload: { stageId, stageData } });

export const updateStageSuccess = (stage) =>
    ({ type: UPDATE_STAGE.SUCCESS, payload: stage });

export const updateStageFailure = (error) =>
    ({ type: UPDATE_STAGE.FAILURE, payload: error });

// ==================== UI STATE ====================

export const setStageFilters = (filters) =>
    ({ type: SET_STAGE_FILTERS, payload: filters });

export const setStageSort = (sortBy, order) =>
    ({ type: SET_STAGE_SORT, payload: { sortBy, order } });

export const clearStages = () =>
    ({ type: CLEAR_STAGES });
